import React, { useEffect, useState } from 'react';
import { ScheduleNotaryCamForm } from './schedule-notary-cam-form';
interface RequestFeedbackFormProps {
  changesRequested?: {
    [key: string]: boolean;
  };
  onSave: (data: { id: string; messages: { id: string; embedding: string }[] }) => Promise<void>;
  isAdmin: boolean;
  caseId: string;
  completed: boolean;
  checked: boolean;
  messageId: string;
}

export const RequestFeedbackForm: React.FC<RequestFeedbackFormProps> = (props) => {
  const [changesRequested, setChangesRequested] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    setChangesRequested(props.changesRequested || {});
  }, [props.changesRequested]);

  const fieldLabels: Record<string, string> = {
    requestUpdatedCredentialDetails: 'Credential Details',
    requestUpdatedIssuingInstitution: 'Issuing Institution',
    requestUploadCredential: 'Credential Upload',
    requestUploadTranslation: 'Credential Translation',
    requestUpdatedPassportDetails: 'Passport Details',
    requestUploadExpirationPage: 'Passport Expiration',
    requestUploadPassportTranslation: 'Passport Translation',
    requestUploadPassport: 'Passport Upload',
    requestUploadPhoto: 'Passport Photo',
    requestScheduleNotaryCam: 'Notary Cam Schedule',
    requestUploadNotarizedIdForm: 'Notarized ID Form',
    requestUpdatedDestination: 'Destination'
  };

  const generateContent = () => {
    return Object.keys(changesRequested)
      .map((key) => {
        if (changesRequested[key] === true) {
          return (
            <li key={key}>
              <b>{fieldLabels[key] || key}</b>
            </li>
          );
        }
        return null;
      })
      .filter((item) => item !== null);
  };

  const content = generateContent();

  const tabNamesInstructions = (() => {
    const hasNotarizedIdForm = props.changesRequested?.['requestUploadNotarizedIdForm'];
    const hasOtherChanges = Object.keys(props.changesRequested || {}).some((key) => key !== 'requestUploadNotarizedIdForm' && props.changesRequested?.[key]);

    if (hasNotarizedIdForm && hasOtherChanges) {
      return 'Files and Application';
    } else if (hasNotarizedIdForm) {
      return 'Files';
    } else {
      return 'Application';
    }
  })();

  return (
    <div
      style={{
        backgroundColor: 'white',
        paddingTop: '20px',
        paddingBottom: '40px',
        paddingLeft: '20px',
        paddingRight: '20px',
        margin: 10,
        marginRight: 30,
        textAlign: 'left',
        border: '1px solid #d9d9d9',
        borderRadius: '8px'
      }}
    >
      {changesRequested['requestScheduleNotaryCam'] === true ? (
        <ScheduleNotaryCamForm
          changesRequested={props.changesRequested}
          onSave={props.onSave}
          caseId={props.caseId}
          completed={props.completed}
          checked={props.checked}
          messageId={props.messageId}
        />
      ) : (
        <>
          {props.isAdmin ? `The applicant's application has been opened and can now update the:` : `Your application is unlocked, you can update the:`}
          <br />
          <br />
          {content.length > 0 && (props.isAdmin ? <ul>{content}</ul> : <div>{content}</div>)}
          <br />
          {props.isAdmin ? `in the ${tabNamesInstructions} tab.` : `in the ${tabNamesInstructions} tab above.`}
        </>
      )}
    </div>
  );
};
